// extracted by mini-css-extract-plugin
export default {"wrap404":"PageNotFound_wrap404__EEdlK","notFoundContent":"PageNotFound_notFoundContent__6KTVP","notFoundMsg":"PageNotFound_notFoundMsg__BwEk9"};